import { executeRequest, Request } from '@jfs/network'
import { banksParser } from './../network/parsers/UserParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfigWithAuthCred } from './config'

const responseParser = (data: any) => {
  const respData = banksParser(data?.response?.bankDetails ?? [], false)
  const favBanks = banksParser(data?.response?.favBankDetails ?? [], true)
  return [...favBanks, ...respData]
}

const getBanks = (tokens: any, userAccessToken: string, mobile: string) => {
  const request: Request<{}> = {
    config: sitConfigWithAuthCred(tokens, mobile),
    apiPath: APIEndPoints.banksList,
    method: 'GET',
    cache: false,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { getBanks }
